<template>
  <v-row>
    <v-col>
      <Allergy :attendance="attendance" :showForm="false" :allowDelete="false" />

      <SurgeryDetail :surgery="surgery" />

      <ProsthesisList
        :surgeryIndicationProstheses="surgery.surgeryIndication.prostheses"
        :surgeryIndication="surgery.surgeryIndication"
        :showForm="false"
        :onlyChosen="true"
        :allowDelete="false"
        :allowEdit="false"
        @update-surgery-indication-prostheses="updateProstheses"
      />

      <v-row>
        <v-col>
          <v-textarea
            label="Notas"
            v-model="observation"
            placeholder=" "
            hide-details
            outlined
            background-color="white"
            @change="saveSurgery"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-row dense>
            <v-col class="text-h5 gray--text">
              Termos de Consentimento
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <FileUpload
                ownerType="Surgery::ConsementTerm"
                :ownerId="surgery.consementTerm.id"
                :disabled="disabled"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col>
          <v-row dense>
            <v-col class="text-h5 gray--text">
              Anexos
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <FileUpload
                ownerType="Surgery::Attachment"
                :ownerId="surgery.attachment.id"
                :disabled="disabled"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import ProsthesisList from "@/components/surgery_indication/prosthesis/list/index.vue";
  import Allergy from "@/components/medical_record/hpp/allergy.vue";
  import SurgeryDetail from "@/components/surgery/detail.vue";

  export default {
    name: "SurgeryDetails",
    props: {
      surgery: Object,
      refreshSurgery: Function,
      setSurgeryMoment: Function,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      ProsthesisList,
      Allergy,
      SurgeryDetail,
    },
    mounted() {
      this.observation = this.surgery.observation;
      this.setSurgeryMoment(null);
    },
    data() {
      return {
        observation: "",
      };
    },
    computed: {
      attendance() {
        return this.surgery.attendance;
      },
    },
    methods: {
      saveSurgery() {
        if (this.disabled) return;

        return this.apolloMutate({
          mutation: require("@/graphql/surgery/save_surgery.gql"),
          variables: {
            surgeryId: this.surgery.id,
            observation: this.observation,
          },
        }).then(() => {
          this.refreshSurgery();
        });
      },
      updateProstheses(prostheses) {
        this.surgery.surgeryIndication.prostheses = prostheses;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
